import { useMemo } from 'react';
import { debounce } from 'lodash';

export default function useDebounce(...args) {
    const dependencies = args.pop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => debounce(...args), dependencies);
}
